var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section"},[_c('header',[_c('h3',[_vm._v("\n      "+_vm._s(_vm.vocabList.name)+"\n    ")])]),_vm._v(" "),_c('ul',{staticClass:"tw-columns-2 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-px-3 tw-pb-3 tw-pt-1.5 md:tw-columns-3"},_vm._l((_vm.vocabList.words),function(word){return _c('li',{key:word,staticClass:"tw-px-0 tw-py-1.5"},[_vm._v("\n      "+_vm._s(word)+"\n    ")])}),0),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":_vm.$config.wpURL +
        '/' +
        _vm.country +
        '/widget/word-search/?vocab_list_id=' +
        _vm.vocabList.id +
        '&title=' +
        encodeURIComponent(_vm.vocabList.name) +
        '&amp_device_id=' +
        _setup.deviceId,"title":"Go to Word Search widget"}},[_vm._v("\n      Create a Word Search with these words →\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }